var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('a-card',{attrs:{"bordered":false}},[_vm._v(" 欢迎使用~ ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }